import moment from 'moment';
import randomColor from 'randomcolor';
import Papa from 'papaparse'; // Manages CSVs
import ResourceUtils from './resource-utils';

const _defaultDataSet = {
    label: '',
    pointRadius: 1,
    pointHitRadius: 10,
    lineTension: 0
}

export class ReportChartAdapter {
    constructor(reportData, defaultDataSet) {
        this.legend = reportData.testResults.sampleDates.map(dateString => moment(dateString).format('MMMM \'YY')).reverse();
        this.data = reportData.testResults.testParams || [];
        this.charts = [];
        this.defaultDataSet = defaultDataSet;

        this.data.forEach(params => {
            let set = this.parseDataset(params);
            if (set) {
                this.charts.push({
                    labels: this.legend,
                    datasets: [
                        set
                    ]
                });
            }
        });
    }

    parseDataset(params) {
        let label = params.name || '';
        let dataError = false;
        let results = params.results || [];
        let data = [];

        for (var i = 0; i < results.length; i++) {
            let res = results[i];
            let num = Number(res);

            // Check to see if the data parsed correctly
            dataError = isNaN(num);
            if (dataError) {
                // If there was an error parsing, this whole dataset is invalidated.  Return false to notify the calling method.
                return false;
            }

            data.unshift(res);
        }

        return Object.assign({}, _defaultDataSet, this.defaultDataSet, {
            label,
            borderColor: randomColor({
                seed: label
            }),
            fillColor: randomColor({
                seed: label
            }),
            data
        });
    }
}

const csvDateFormat = 'MM/DD/YYYY';

export class ReportCSV {
    constructor(report) {
        let headers = [
            'Sample Number',
            ...report.testResults.samples
        ];

        let sampleDates = [
            'Sample Dates',
            ...report.testResults.sampleDates.map(date => moment(date).format(csvDateFormat))
        ];

        let receivedDates = [
            'Received Dates',
            ...report.testResults.receivedDates.map(date => moment(date).format(csvDateFormat))
        ];

        let data = report.testResults.testParams.map(dataset => {
            return [
                dataset.name,
                ...dataset.results
            ]
        });

        this.csv = [
            headers,
            sampleDates,
            receivedDates,
            ...data
        ]

        this.reportNumber = report.reportNumber;
        this.reportDate = report.reportDate;
    }

    toString() {
        return Papa.unparse(this.csv);
    }

    save() {
        let csvString = this.toString();
        let blob = new Blob([csvString], { type: 'text/csv' });
        ResourceUtils.downloadBlob(blob, {
            fileName: `${this.reportNumber}-${moment(this.reportDate).format('MMMM-YYYY')}.csv`
        });
    }
}



// WEBPACK FOOTER //
// ./web-app/utils/report-utils.js